import 'jquery-accessible-accordion-aria'
import 'jquery.easing'
import 'mlmi-library/plugins/scroll-to'

const INITIAL_MAX_HEIGHT = 100

export default {
  init() {
    $('.js-accordion').each(function() {
      let accordion = $(this)
      let multiselectable = $(this).hasClass('faq')
      accordion.accordion({
        buttonsGeneratedContent: 'html',
        multiselectable: multiselectable,
      })
      accordion.find('.accordion__header').on('click', function() {
        let header = $(this), currentTab = $('.accordion__header[aria-expanded="true"]').closest('.js-accordion__item')
        if (header.attr('aria-expanded') == 'true') {
          //
        } else {
          let targetTop = accordion.offset().top,
          newItem = header.closest('.js-accordion__item')
          newItem.prevAll('.js-accordion__item').each(function() {
            targetTop += $(this).find('.accordion__header').outerHeight(false)
          })
          if ($.mlmi.mobile.isMobile) {
            targetTop -= $('.mobile-header').outerHeight(false)
          }
          setTimeout(function() {
            $('body, html').scrollTo(targetTop, 550, 8, 'easeInOutQuart')
          }, 350);
        }
      })
      accordion.find('.accordion__panel').each(function() {
        let accordionPanel = $(this)

        accordionPanel.sizer = function() {
          let textContent = accordionPanel.find('.accordion__panel-content')
          let outerHeight = textContent.outerHeight(false)
          accordionPanel.css('max-height', outerHeight > INITIAL_MAX_HEIGHT ? outerHeight + 'px' : '')
        }

        $(window).on('resize load orientationchange', accordionPanel.sizer)
        accordionPanel.sizer()
      })
    })
  },
}
